/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Nested payment method from VGS. Send snake_case property names.
 * All properties optional.
 * 
 * @export
 * @interface ApplePayPaymentMethodInfo
 */
export interface ApplePayPaymentMethodInfo {
    /**
     * Card network (e.g. visa, mastercard, amex, discover).
     * @type {string}
     * @memberof ApplePayPaymentMethodInfo
     */
    network?: string;
    /**
     * Card brand (alternative to network).
     * @type {string}
     * @memberof ApplePayPaymentMethodInfo
     */
    brand?: string;
}

/**
 * Check if a given object implements the ApplePayPaymentMethodInfo interface.
 */
export function instanceOfApplePayPaymentMethodInfo(value: object): value is ApplePayPaymentMethodInfo {
    return true;
}

export function ApplePayPaymentMethodInfoFromJSON(json: any): ApplePayPaymentMethodInfo {
    return ApplePayPaymentMethodInfoFromJSONTyped(json, false);
}

export function ApplePayPaymentMethodInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplePayPaymentMethodInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'network': json['network'] == null ? undefined : json['network'],
        'brand': json['brand'] == null ? undefined : json['brand'],
    };
}

export function ApplePayPaymentMethodInfoToJSON(json: any): ApplePayPaymentMethodInfo {
    return ApplePayPaymentMethodInfoToJSONTyped(json, false);
}

export function ApplePayPaymentMethodInfoToJSONTyped(value?: ApplePayPaymentMethodInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'network': value['network'],
        'brand': value['brand'],
    };
}

